exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heading-w-line[data-v-34bc5390] {\n  margin-bottom: 60px;\n}\n.heading-w-line h2[data-v-34bc5390] {\n  margin-bottom: 0px;\n}\n.line[data-v-34bc5390] {\n  width: 100%;\n  height: 20px;\n  border-bottom: 1px black solid;\n  border-right: 1px black solid;\n}\n.line.white[data-v-34bc5390] {\n  border-bottom: 1px white solid;\n  border-right: 1px white solid;\n}\n", ""]);

// exports
